/**
 * Deterministic WhatsApp task-brief builder for "Assign Task via WhatsApp"
 * (Command Center / CMO / Campaign Playbook). Zero LLM, zero fabrication —
 * only ever uses fields already surfaced on the task card, plus the
 * secure "Open Task & Playbook" share-link minted by the backend
 * (`api.assignLinkMint`). Any field that doesn't exist on the task is
 * simply omitted, never invented.
 */

const PRIORITY_LABEL = { 1: "High", 2: "High", 3: "Medium", 4: "Low", 5: "Low" };

export function priorityLabel(priority) {
  if (priority == null) return null;
  return PRIORITY_LABEL[priority] || `P${priority}`;
}

/** `shareUrl` is the secure, no-login employee link (see AssignTaskModal —
 * minted just-in-time via `api.assignLinkMint` before this is called). */
export function buildWhatsAppMessage(item, shareUrl) {
  if (!item) return "";
  const lines = ["*C-ORE Task Assigned*", "", `Task: ${item.title || ""}`];
  const pr = priorityLabel(item.priority);
  if (pr) lines.push(`Priority: ${pr}`);
  if (item.due_timeline) lines.push(`Due: ${item.due_timeline}`);
  if (item.detail) lines.push("", "What to do:", item.detail);
  if (shareUrl) lines.push("", "Open Task & Playbook:", shareUrl);
  lines.push("", "Please complete by the due date.");
  lines.push("", "— Shared from C-ORE");
  return lines.join("\n");
}
